import BaseCard from './BaseCard';
import TransformComponent from '../../../Component/Transform';

export default class CanisterPreBoosterCard extends BaseCard {
    public onCreate(params: any): void {
        super.onCreate({...params,
            cardFrontTexture: 'blank',
            cardBackTexture: 'blank',
            dragonbonesName: 'booster_card_canister',
            armatureName: 'Armature'
        });

        const armature = this.getArmature();
        const armatureTransform = armature.getComponent(TransformComponent);
        armatureTransform.y = 23;
    }
}
